var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerBox"},[_c('div',{staticClass:"whiteCircle",class:[
      _vm.isOrder ? 'whiteCircle-isOrder' : '',
      _vm.hasOrderCircleBackground ? 'whiteCircle-hasOrderCircleBackground' : '',
      _vm.isPayment ? 'whiteCircle-isPayment' : '',
      _vm.isPaymentStart ? 'whiteCircle-isPaymentStart' : '',
      _vm.isPaymentSuccess ? 'whiteCircle-isPaymentSuccess' : ''
    ]})])}
var staticRenderFns = []

export { render, staticRenderFns }